import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import ServiceAreaMap from './components/ServiceAreaMap';
import ReviewsSection from './components/ReviewsSection';
import SocialGallery from './components/SocialGallery';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <HeroSection />
        <ServicesGrid />
        <ServiceAreaMap />
        <ReviewsSection />
        <SocialGallery />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;